import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  token_order: null,
};

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    getTokenOrder: (_state, _action) => {},
    getTokenOrderSuccess: (state, action) => {
      state.token_order = action.payload?.token;
    },
  },
});

export const authAction = authSlice.actions;
export const authReducer = authSlice.reducer;
